import { Flex, Tooltip, Typography } from "antd"

import ButtonComponent from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import Icon from "../../../../Icon"
import { alertsColumnIconMap } from "../../../../Utils/utils"

const { Text } = Typography

const formatPrice = (value) =>
  value === null || value === undefined ? "-" : `$ ${Number(value).toFixed(2)}`

const sortableTitle = ({ key, title, icon }) => ({
  key,
  sorter: true,
  dataIndex: key,
  title: (state) => titleSortFilters({ title, sorter: true, icon, stateData: state, key })
})

// Channel prices carry no card-network icon: a lookup channel is not a card network (req. 3).
const priceColumn = (key, title) => ({
  ...sortableTitle({ key, title }),
  width: 150,
  render: (value) => (
    <Text>
      <Private>{formatPrice(value)}</Private>
    </Text>
  )
})

export const getLookupColumns = ({ onSelectRow }) => {
  const handleAction = (e, record, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow(record, type)
  }

  return [
    // {
    //   ...sortableTitle({ key: "number", title: null, icon: alertsColumnIconMap["sequence_number"] }),
    //   width: 80,
    //   fixed: "left"
    // },
    {
      ...sortableTitle({
        key: "name",
        title: "Pricing scheme"
        // icon: alertsColumnIconMap["pricing_schema"]
      }),
      width: 220,
      ellipsis: true
    },
    priceColumn("banking_app_price", "Banking app"),
    priceColumn("call_center_price", "Call Center"),
    priceColumn("mastercom_price", "Mastercom"),
    {
      ...sortableTitle({
        key: "free_count",
        title: "Free lookups",
        icon: alertsColumnIconMap["free_lookups"]
      }),
      width: 170
    },
    {
      ...sortableTitle({ key: "applied", title: "Applied", icon: alertsColumnIconMap["applied"] }),
      width: 130,
      render: (value) => (value ? "Yes" : "No")
    },
    {
      key: "action",
      title: "Actions",
      width: 118,
      render: (_, record) => (
        <Flex gap={4}>
          {/* Tooltips stay mounted once shown, so their ids are per row, not shared. */}
          <Tooltip
            title={<span data-testid={`lookup-pricing-edit-tooltip-${record.id}`}>Edit</span>}
          >
            <ButtonComponent
              type="link"
              shape="circle"
              icon={<Icon type="settings" />}
              onClick={(e) => handleAction(e, record, "edit")}
              className="flex center"
              data-testid={`lookup-pricing-edit-button-${record.id}`}
            />
          </Tooltip>

          <Tooltip
            title={
              <span data-testid={`lookup-pricing-delete-tooltip-${record.id}`}>
                {record.is_default ? "You can not delete default pricing." : "Delete"}
              </span>
            }
          >
            <ButtonComponent
              danger
              type="link"
              shape="circle"
              icon={<Icon type="delete" />}
              onClick={(e) => handleAction(e, record, "delete")}
              disabled={record.is_default}
              className="flex center table-action-btn"
              data-testid={`lookup-pricing-delete-button-${record.id}`}
            />
          </Tooltip>
        </Flex>
      )
    }
  ]
}
